import React, { ComponentType } from 'react'
import { Segment } from 'semantic-ui-react'
import { connect } from 'react-redux'
// Local
import {
  PATIENT_RULES,
  shouldRenderReskin2025
} from '../../../constant'
import { cdiRuleFilterAndRuleRiskCategoryVersionEnabled } from '../../common/currentUserUtils'
import { Patient } from '../../patient/patient'
import { RootState } from '../../../store'

type BreakOrSpaceProps = {
  shouldBreak: boolean
}

function BreakOrSpace(
  props: BreakOrSpaceProps
): JSX.Element {
  const { shouldBreak } = props
  if (shouldBreak) return <br />
  return <>&nbsp;</>
}

const SafeSegment = Segment as unknown as ComponentType<any>

/**
 * Provides a component that renders the patient rule HCC version, if provided
 *
 * @param patient Patient entity
 * @param mode Render mode. Default: left
 */

const mapStateToProps = (state: RootState) => ({
  currentUser: state.user
})

type ReduxStateProps = ReturnType<typeof mapStateToProps>

type Props = ReduxStateProps & {
  patient: Patient | undefined
  mode?: string | undefined
}

function PatientRuleHccVersion(
  props: Props
): JSX.Element | null {
  const {
    currentUser,
    patient,
    mode = 'left'
  } = props

  if (mode === 'left') {
    if (!cdiRuleFilterAndRuleRiskCategoryVersionEnabled(currentUser)) return null

    if (patient && patient.rulesHccVersion) {
      return (
        <SafeSegment
          attached
          compact
          className="left-segment"
        >
          <div className="left-title">
            Patient Rule Risk
            <BreakOrSpace shouldBreak={ !shouldRenderReskin2025 } />
            Category Version:
          </div>
          <div className="left-content">
            { patient.rulesHccVersion }
          </div>
        </SafeSegment>
      )
    }
    return (
      <SafeSegment
        attached
        compact
        className="left-segment"
      >
        <div className="left-title">
          Patient Rule Risk
          <BreakOrSpace shouldBreak={ !shouldRenderReskin2025 } />
          Category Version:
        </div>
        <div className="left-content">
          { PATIENT_RULES.PATIENT_RULE_RISK_CATEGORY_VERSION }
        </div>
      </SafeSegment>
    )

  }
  return null

}

export default connect(mapStateToProps)(PatientRuleHccVersion)
